import PlaceholderPage from '@/pages/placeholder/page';

export default function OfficePage() {
  return (
    <PlaceholderPage
      title="Office"
      icon="ri-folder-open-line"
      description="Xem thông báo nội bộ, hướng dẫn, chính sách, quy định dưới dạng PDF hoặc link Google Drive của công ty."
      phase={4}
    />
  );
}